import { useEffect, useLayoutEffect, useState } from "react";

// router
import { useNavigate, useParams } from "react-router-dom";

// bootstrap
import { Button, Container } from "react-bootstrap";

// componentes
import Migas from "../migasGeomedellin/Migas";
import PiePagina from "../piePagina/PiePagina";
import Rating from "../../common/Rating";
import Load from "../../common/Load";

// http services request
import getDatos from "../../../services/getDatos";
import guardarUbicacion from "../../../services/guardarUbicacion";

// Variables globales
import { URL_IMAGE_GEOMEDELLIN } from "../../../environment";

export default function InfoNoticias ({
  idComponente,
  caracFiltro,
  imagen,
  descripcion,
}) {
  const { id } = useParams();
  const navigate = useNavigate();

  // data openData
  const [noticiaInfo, setNoticiaInfo] = useState([]);

  // Load
  const [load, setLoad] = useState(false);

  useEffect(() => {
  }, []);

  const obtenerNoticia = async () => {
    setLoad(true);
    try {
      const responseNoticias = await getDatos(`geomed/noticias/${id}`);
      setNoticiaInfo(responseNoticias);
    } catch (err) {
      alert("Error");
      navigate("/noticias");
    } finally {
      setLoad(false);
    }
  };

  const mostrarImgNoticia = () => {
    const { imagen, id_noticia } = noticiaInfo;
    if (imagen?.includes("https://www.medellin.gov.co/")) {
      return imagen;
    }
    return `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Noticias/${id_noticia}/${imagen}`;
  };

  useLayoutEffect(() => {
    obtenerNoticia();
    window.scroll(0, 0);
  }, [id]);

  return (
    <>
      <Container fluid={true} className="content-datosabiertos">
        <div
          className="img-logo-datosabiertos"
          style={{
            backgroundImage: `url("${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Banner/${idComponente}/${imagen}")`,
          }}
        >
          <div className="content-degradado">
            <div className="content-contendido-img-banner">
              <label className="lblitulo-txt-imgbanner">Noticias</label>
              <p>
                <label className="lbdescripcion-txt-imgbanner">
                  {descripcion}
                </label>
              </p>
            </div>
          </div>
          <label className="color-borde-img-banner"></label>
        </div>
        <Migas ruta="Noticias" />
        <Container>
          <div className="grid-container-info-noticias" key={noticiaInfo?.id_noticia}>
            <div className="div-img-info-noticias">
              <img
                src={mostrarImgNoticia()}
                className="img-info-noticias"
                alt={
                  noticiaInfo?.imagen
                    ? noticiaInfo?.imagen
                    : noticiaInfo?.nombre
                }
              />
            </div>
            <div className="info-noticias-seccion">
              <p className="titulo-noticia">{noticiaInfo?.nombre}</p>
              <span>{noticiaInfo?.descripcion}</span>
            </div>
            { noticiaInfo.archivo &&
              <div className="info-noticias-seccion">
                <a
                  style={{'text-decoration': 'none'}}
                  href={`${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Noticias/${noticiaInfo?.id_noticia}/${noticiaInfo?.archivo}`}
                  target="_blank"
                  rel={"noreferrer"}
                  download
                  onClick={async () =>
                    await guardarUbicacion(
                      7,
                      "1",
                      noticiaInfo.id_noticia
                    )
                  }
                >
                  <Button className="btn-ira-tarjeta">
                    DESCARGAR ARCHIVO
                  </Button>
                </a>
              </div>
            }
          </div>
        </Container>
        <Load visible={load} />
      </Container>
      <PiePagina fluid={true} />
    </>
  );
};
